<template>
  <div id="app">
    <Header />
    <Navbar v-if="!$route.meta.hideNavbar" />
    <div id="main">
      <!-- <keep-alive> -->
        <router-view/>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
    font-family: 'Garamond';
    src: url('./assets/fonts/EBGaramond-Regular.ttf');
}

* {
  box-sizing: border-box;
}

$debug: false;

body {
  // background: url("./assets/bg_maink.jpg") repeat fixed;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
  /* background-size: cover; */
  padding-bottom: 10px;
}

@if $debug == true {
  @include respond-above(lg) {
    body {
      background: url("./assets/bg_main_lg.jpg") repeat fixed;
    }
  }

  @include respond-between(md, lg) {
    body {
      background: url("./assets/bg_main_md.jpg") repeat fixed;
    }
  }

  @include respond-between(sm, md) {
    body {
      background: url("./assets/bg_main_sm.jpg") repeat fixed;
    }
  }

  @include respond-below(sm) {
    body {
      background: url("./assets/bg_main_xs.jpg") repeat fixed;
    }
  }
} @else {
  body {
    background: url("./assets/bg_main.jpg") repeat fixed;
  }
}

#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
  font-family: 'Garamond';
  font-size: 21px;
  color: #2c3e50;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // background-color: beige;
}

#main {
    flex: 4;
    min-height: 60vh;
    // border: solid 1px #FF0000;
    // background-color: rgb(166, 206, 241);

    @if $debug == true {
      // background-color: rgb(166, 206, 241);
      // border: solid 1px #FF0000;
    }
}

#title {
  background: url("./assets/lamujercambiante-1000.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 20px;
  padding-left: 30px;
  filter: drop-shadow(0px 0px 3px rgb(14, 14, 14));
  // height: 80px;
}

h2 {
  // font-size: 24px;
  letter-spacing: 3px;
  font-weight: 900;
  text-align: right;
  padding-right: 19%;
}
</style>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'App',
  components: {
    Header,
    Navbar
  },
  watch: {
    '$route' (to, from) {
      console.log('route: ' + to.fullPath)
    }
  }
}

</script>
